import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BuffetIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M14 4a1 1 0 00-1-1h-2a1 1 0 100 2v1H7a3 3 0 00-3 3v2H3a1 1 0 100 2v2a3 3 0 003 3h.929c-.167 1.04-.625 1.7-1.371 2.067a1 1 0 10.884 1.794c1.459-.718 2.29-2.043 2.503-3.861h6.112c.216 1.807 1.048 3.125 2.5 3.84a1 1 0 00.885-1.793c-.74-.365-1.199-1.02-1.368-2.047H18a3 3 0 003-3v-2a1 1 0 100-2h-1V9a3 3 0 00-3-3h-4V5a1 1 0 001-1zm4 7V9a1 1 0 00-.883-.993L17 8H7a1 1 0 00-1 1v2h12zm1 2H5v2a1 1 0 00.883.993L6 16h12a1 1 0 001-1v-2z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
BuffetIcon.isCarinaIcon = true;
export default BuffetIcon;
